import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import t from "utils/translate";
import { pageView } from "utils/analytics";
import routes from "routes";
import { useCashPayWegovy } from "utils/useCashPayWegovy";

import { TREATMENT, WEGOVY } from "components/ClinicCheckout/constants";
import Column from "components/Column";
import SiteWrapper from "components/SiteWrapper";
import Cards from "components/ClinicCheckout/TreatmentOptions/Cards";
import StickyFooter from "components/StickyFooter";

import styles from "components/ClinicCheckout/TreatmentOptions/styles.module.scss";

export const ResultsUni5TreatmentOptions: React.FC<{ resultsRestored?: boolean }> = ({ resultsRestored = false }) => {
  const history = useHistory();
  const { cashPayWegovyEligible, cashPayWegovyIsReady } = useCashPayWegovy();

  const [selectedTreatment, setSelectedTreatment] = useState(WEGOVY);

  useEffect(() => {
    pageView("treatment-options");
  }, []);

  // Redirect users to plans page if the cash pay wegovy flag is not enabled.
  useEffect(() => {
    if (
      cashPayWegovyIsReady &&
      !cashPayWegovyEligible
    ) {
      continueToPlans(true);
    }
  }, [cashPayWegovyEligible, cashPayWegovyIsReady]);

  const continueToPlans = (noTreatment = false) => {
    const treatment = noTreatment ? null : selectedTreatment;
  
    const urlParams = new URLSearchParams();
    if (treatment) {
      urlParams.append(TREATMENT, treatment);
    }

    const paramString = urlParams.toString();

    // If no offer bundle is provided, the plans page will fall back to a default bundle.
    history.push(
      `${resultsRestored ? routes.plansRestored : routes.plans}${paramString ? `?${paramString}` : ""}`
    );
  };

  return (
    <SiteWrapper size="small">
      <Column className={styles.content}>
        <h1 className={styles.title}>{t("COMPOUND_CHECKOUT_PAGE_TITLE")}</h1>
        <p className={styles.subtitle}>
          {t("COMPOUND_CHECKOUT_PAGE_SUBTITLE")}
        </p>
        <Cards
          selectedTreatment={selectedTreatment}
          setSelectedTreatment={setSelectedTreatment}
        />
        <StickyFooter
          className={styles.footer}
          nextButtonProps={{
            onNext: continueToPlans,
            label: t("CONTINUE"),
            "da-category": "compound_checkout",
            "da-label": `treatment_options:${selectedTreatment}`,
            "da-action": "next"
          }}
        />
      </Column>
    </SiteWrapper>
  );
};
